import { Modal } from "react-bootstrap";
import { ACTION_TYPE, REPORT_NAME } from "../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { useBulkSaveDocumentTypeMutation, useFindAllDocumentTypeMutation, useGetDocumentTypeByIdMutation, useSaveDocumentTypeMutation, useUpdateDocumentTypeMutation } from "../../redux-toolkit/services/documentTypeService";
import { useBulkSaveDocumentMasterMutation, useFindAllDocumentMasterMutation, useGetDocumentMasterByIdMutation, useSaveDocumentMasterMutation, useUpdateDocumentMasterMutation } from "../../redux-toolkit/services/documentMasterService";
import { allDocumentTypeDetails, getAllDocumentTypeDetails, setAllDocumentType } from "../../redux-toolkit/slices/documentTypeSlice";
import { getAllDocumentMasterDetails } from "../../redux-toolkit/slices/documentMasterSlice";
import { allEntityTypeMasterDetails, setAllEntityTypeMaster } from "../../redux-toolkit/slices/entityTypeMasterSlice";
import { useFindAllEntityTypeMasterMutation } from "../../redux-toolkit/services/entityTypeMasterService";
import { format, parseISO } from "date-fns";
import { useFindAllEntityMasterMutation } from "../../redux-toolkit/services/entityMasterService";
import { allEntityMasterDetails, setAllEntityMaster } from "../../redux-toolkit/slices/entityMasterSlice";
import { useFindAllUsersMutation } from "../../redux-toolkit/services/allUserService";
import { allUsersDetails, setAllUser } from "../../redux-toolkit/slices/allUserSlice";
import { useFindAllAssetTypeMutation } from "../../redux-toolkit/services/assetTypeService";
import { useFindAllAssetsMutation } from "../../redux-toolkit/services/assetsService";
import { allAssetTypeDetails, setAllAssetType } from "../../redux-toolkit/slices/assetTypeSlice";
import { allAssetsDetails, setAllAssets } from "../../redux-toolkit/slices/assetsSlice";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
};

const DocumentDate = (props: Props) => {

    const localUserObj: any = getLocalStorageData("localUser");
    const dispatch = useDispatch();

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [activeTab, setActiveTab] = useState<"manual" | "bulk">("manual");
    const [fileName, setFileName] = useState("");

    //save
    const [saveDocumentType, saveDocumentTypeResponse] = useSaveDocumentTypeMutation();
    const [saveDocumentMaster, saveDocumentMasterResponse] = useSaveDocumentMasterMutation();

    //bulk
    const [bulkSaveDocumentType, bulkSaveDocumentTypeResponse] = useBulkSaveDocumentTypeMutation();
    const [bulkSaveDocumentMaster, bulkSaveDocumentMasterResponse] = useBulkSaveDocumentMasterMutation();

    //update
    const [updateDocumentType, updateDocumentTypeResponse] = useUpdateDocumentTypeMutation();
    const [updateDocumentMaster, updateDocumentMasterResponse] = useUpdateDocumentMasterMutation();

    //getById mutation
    const [getDocumentTypeById, documentCategoryByIdResponse] = useGetDocumentTypeByIdMutation();
    const [getDocumentMasterById, documentMasterByIdResponse] = useGetDocumentMasterByIdMutation();

    //getAllData
    const [findAllDocumentType, findAllDocumentTypeResponse] = useFindAllDocumentTypeMutation();
    const [findAllDocumentMasters, findAllDocumentMastersResponse] = useFindAllDocumentMasterMutation();
    const [getAllEntityTypes, getAllEntityTypesResponse] = useFindAllEntityTypeMasterMutation();
    const [findAllEntity, findAllEntityResponse] = useFindAllEntityMasterMutation();
    const [findAllUsers, findAllUsersResponse] = useFindAllUsersMutation();
    const [findAllAssetType, findAllAssetTypeResponse] = useFindAllAssetTypeMutation();
    const [findAllAssets, findAllAssetsResponse] = useFindAllAssetsMutation();

    //Data

    const allDocumentTypeData: any = useAppSelector(allDocumentTypeDetails);
    const allDocumentMasterData: any = useAppSelector(getAllDocumentMasterDetails);
    const allEntityTypes: any = useAppSelector(allEntityTypeMasterDetails);
    const allEntityMaster: any = useAppSelector(allEntityMasterDetails);
    const allUsers: any = useAppSelector(allUsersDetails);
    const allAssetType: any = useAppSelector(allAssetTypeDetails);
    const allAssets: any = useAppSelector(allAssetsDetails);

    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.DOCUMENT_TYPE) {
                getDocumentTypeById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                getAllEntityTypes({ token: localUserObj?.token, });
            } else if (props.reportName === REPORT_NAME.DOCUMENT_MASTER) {
                findAllEntity({ token: localUserObj?.token });
                getAllEntityTypes({ token: localUserObj?.token });
                findAllDocumentType({ token: localUserObj?.token });
                findAllUsers({ token: localUserObj?.token })
                findAllAssetType({ token: localUserObj?.token });
                findAllAssets({ token: localUserObj?.token });
                getDocumentMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
            }
        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.DOCUMENT_TYPE) {
                getAllEntityTypes({ token: localUserObj?.token, });
            } else if (props.reportName === REPORT_NAME.DOCUMENT_MASTER) {
                findAllAssetType({ token: localUserObj?.token });
                findAllAssets({ token: localUserObj?.token });
                findAllEntity({ token: localUserObj?.token });
                getAllEntityTypes({ token: localUserObj?.token });
                findAllDocumentType({ token: localUserObj?.token });
                findAllUsers({ token: localUserObj?.token })
            }
        }
    }, [props.reportName]);


    const handleClose = () => {
        props.setShow(false);
    };

    const handleSubmit = (values: any) => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.DOCUMENT_TYPE) {
                const payload = {
                    code: values.code,
                    name: values.name,
                    entityTypeId: parseInt(values.entityTypeId),
                    isMandatory: values.expiryApplicable,
                    expiryApplicable: values.isMandatory,
                    fileFormat: values.fileFormat,
                    description: values.description,
                    status: true,
                }

                saveDocumentType({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.DOCUMENT_MASTER) {

                const payload = {
                    entityId: parseInt(values.entityId),
                    entityTypeId: parseInt(values.entityTypeId),
                    assetId: parseInt(values.assetId),
                    assetTypeId: parseInt(values.assetTypeId),
                    documentTypeId: parseInt(values.documentTypeId),
                    documentNumber: values.documentNumber,
                    documentName: values.documentName,
                    fileName: fileName,
                    registrationDate: values.registrationDate,
                    validDays: values.validDays,
                    expiryDate: values.expiryDate,
                    verificationStatus: values.verificationStatus,
                    verifiedById: values.verifiedById,
                    verifiedDate: values.verifiedDate,
                    remarks: values.remarks,
                    status: true,
                }

                const formData = new FormData();
                formData.append('documentMasterReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                saveDocumentMaster({
                    token: localUserObj?.token,
                    payload: formData,
                });
            }
        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.DOCUMENT_TYPE) {

                const payload = {
                    id: props?.data?.id,
                    code: values.code,
                    name: values.name,
                    entityTypeId: parseInt(values.entityTypeId),
                    isMandatory: values.expiryApplicable,
                    expiryApplicable: values.isMandatory,
                    fileFormat: values.fileFormat,
                    description: values.description,
                    status: props.data.status,

                }
                updateDocumentType({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.DOCUMENT_MASTER) {

                const payload = {
                    id: props?.data?.id,
                    entityId: parseInt(values.entityId),
                    entityTypeId: parseInt(values.entityTypeId),
                    assetId: parseInt(values.assetId),
                    assetTypeId: parseInt(values.assetTypeId),
                    documentTypeId: parseInt(values.documentTypeId),
                    documentNumber: values.documentNumber,
                    documentName: values.documentName,
                    fileName: fileName,
                    registrationDate: values.registrationDate,
                    validDays: values.validDays,
                    expiryDate: values.expiryDate,
                    verificationStatus: values.verificationStatus,
                    verifiedById: values.verifiedById,
                    verifiedDate: values.verifiedDate,
                    remarks: values.remarks,
                    status: props.data.status,
                }

                const formData = new FormData();
                formData.append('documentMasterReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                updateDocumentMaster({
                    token: localUserObj?.token,
                    payload: formData,
                    id: props?.data?.id,
                });
            }
        }
    };

    useEffect(() => {
        if (documentCategoryByIdResponse.isSuccess) {
            setGetByIdData(documentCategoryByIdResponse.data);
        } else if (documentCategoryByIdResponse.isError) {
            let response: any = documentCategoryByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [documentCategoryByIdResponse.isSuccess, documentCategoryByIdResponse.isError]);

    useEffect(() => {
        if (documentMasterByIdResponse.isSuccess) {
            setGetByIdData(documentMasterByIdResponse.data);
        } else if (documentMasterByIdResponse.isError) {
            let response: any = documentMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [documentMasterByIdResponse.isSuccess, documentMasterByIdResponse.isError]);

    useEffect(() => {
        if (getAllEntityTypesResponse.isSuccess) {
            dispatch(setAllEntityTypeMaster(getAllEntityTypesResponse));
        } else if (getAllEntityTypesResponse.isError) {
            alertMessage("Error while fetching Entity Types", "error");
        }
    }, [getAllEntityTypesResponse.isSuccess, getAllEntityTypesResponse.isError]);

    useEffect(() => {
        if (findAllEntityResponse.isSuccess) {
            dispatch(setAllEntityMaster(findAllEntityResponse));
        } else if (findAllEntityResponse.isError) {
            alertMessage("Error while fetching Entity Types", "error");
        }
    }, [findAllEntityResponse.isSuccess, findAllEntityResponse.isError]);

    useEffect(() => {
        if (findAllUsersResponse.isSuccess) {
            console.log(findAllUsersResponse)
            dispatch(setAllUser(findAllUsersResponse));
        } else if (findAllUsersResponse.isError) {
            alertMessage("Error while fetching Users", "error");
        }
    }, [findAllUsersResponse.isSuccess, findAllUsersResponse.isError]);

    useEffect(() => {
        if (findAllDocumentTypeResponse.isSuccess) {
            dispatch(setAllDocumentType(findAllDocumentTypeResponse));
        } else if (findAllDocumentTypeResponse.isError) {
            alertMessage("Error while fetching Entity Types", "error");
        }
    }, [findAllDocumentTypeResponse.isSuccess, findAllDocumentTypeResponse.isError]);

    const handleBulkUpload = (e: any) => {
        const file = e.target.files[0];
        const fileName = e.target.files[0].name;
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "xlsx") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only xlsx files are allowed!", "error");
        }
    };

    const handleBulkSave = () => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            const formData = new FormData();
            if (file) {
                formData.append('file', file);
            }

            if (props.reportName === REPORT_NAME.DOCUMENT_TYPE) {
                bulkSaveDocumentType({
                    payload: formData,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.DOCUMENT_MASTER) {
                bulkSaveDocumentMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }
        }
    }

    useEffect(() => {
        if (saveDocumentTypeResponse.isSuccess) {
            const response: any = saveDocumentTypeResponse.data;
            alertMessage("Document Type added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveDocumentTypeResponse.isError) {
            let response: any = saveDocumentTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveDocumentTypeResponse.isSuccess, saveDocumentTypeResponse.isError]);

    useEffect(() => {
        if (bulkSaveDocumentTypeResponse.isSuccess) {
            const response: any = bulkSaveDocumentTypeResponse.data;
            alertMessage("Document Type added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveDocumentTypeResponse.isError) {
            let response: any = bulkSaveDocumentTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveDocumentTypeResponse.isSuccess, bulkSaveDocumentTypeResponse.isError]);

    useEffect(() => {
        if (updateDocumentTypeResponse.isSuccess) {
            const response: any = updateDocumentTypeResponse.data;
            alertMessage("Document Type updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateDocumentTypeResponse.isError) {
            let response: any = updateDocumentTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateDocumentTypeResponse.isSuccess, updateDocumentTypeResponse.isError]);

    useEffect(() => {
        if (saveDocumentMasterResponse.isSuccess) {
            const response: any = saveDocumentMasterResponse.data;
            alertMessage("Document Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveDocumentMasterResponse.isError) {
            let response: any = saveDocumentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveDocumentMasterResponse.isSuccess, saveDocumentMasterResponse.isError]);

    useEffect(() => {
        if (bulkSaveDocumentMasterResponse.isSuccess) {
            const response: any = bulkSaveDocumentMasterResponse.data;
            alertMessage("Document Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveDocumentMasterResponse.isError) {
            let response: any = bulkSaveDocumentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveDocumentMasterResponse.isSuccess, bulkSaveDocumentMasterResponse.isError]);

    useEffect(() => {
        if (updateDocumentMasterResponse.isSuccess) {
            const response: any = updateDocumentMasterResponse.data;
            alertMessage("Document Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateDocumentMasterResponse.isError) {
            let response: any = updateDocumentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateDocumentMasterResponse.isSuccess, updateDocumentMasterResponse.isError]);

    useEffect(() => {
        if (findAllAssetsResponse.isSuccess) {
            dispatch(setAllAssets(findAllAssetsResponse));
        } else if (findAllAssetsResponse.isError) {
            alertMessage("Error while fetching Assets", "error");
        }
    }, [findAllAssetsResponse.isSuccess, findAllAssetsResponse.isError]);

    useEffect(() => {
        if (findAllAssetTypeResponse.isSuccess) {
            dispatch(setAllAssetType(findAllAssetTypeResponse));
        } else if (findAllAssetTypeResponse.isError) {
            alertMessage("Error while fetching Asset Type", "error");
        }
    }, [findAllAssetTypeResponse.isSuccess, findAllAssetTypeResponse.isError]);

    // upload file...............................
    const fileHandler = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        setFileName(fileName)
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        // if (extFile == "pdf" || extFile == "zip" || extFile == "docx") {
        setFile(e.target.files[0]);
        // } else {
        //     alertMessage("Only pdf and zip files are allowed!", "error");
        // }
    };

    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                // dialogClassName={"modal-90w"}
                {...(
                    props.reportName === REPORT_NAME.USER_SUBSCRIBER || props.reportName === REPORT_NAME.USER_GROUP
                        ? { dialogClassName: "modal-90w" }
                        : { size: "lg" } // default to lg for all others
                )}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold text-accent" style={{ fontSize: "1rem" }}>
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {saveDocumentTypeResponse.isLoading ||
                        saveDocumentMasterResponse.isLoading ||

                        bulkSaveDocumentTypeResponse.isLoading ||
                        bulkSaveDocumentMasterResponse.isLoading ||

                        updateDocumentTypeResponse.isLoading ||
                        updateDocumentMasterResponse.isLoading
                        ? <Loading />
                        : ""
                    }
                    {props.actionType === ACTION_TYPE.ADD_ACTION && (
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'manual' ? 'active text-accent' : 'text-secondary'}`}
                                    onClick={() => setActiveTab('manual')}
                                >
                                    Manual Entry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'bulk' ? 'active text-accent' : 'text-secondary'}`}
                                    onClick={() => setActiveTab('bulk')}
                                >
                                    Bulk Upload
                                </button>
                            </li>
                        </ul>
                    )}

                    {activeTab === "manual" && (
                        <Formik
                            enableReinitialize={true}
                            initialValues={
                                props.reportName === REPORT_NAME.DOCUMENT_TYPE
                                    ? {
                                        code:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.code
                                                : "",
                                        name:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.name
                                                : "",
                                        description:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.description
                                                : "",
                                        entityTypeId:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.entityTypeMaster?.id
                                                : "",
                                        fileFormat:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.fileFormat
                                                : "",
                                        isMandatory:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.isMandatory
                                                : "",
                                        expiryApplicable:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.expiryApplicable
                                                : "",
                                    }
                                    : props.reportName === REPORT_NAME.DOCUMENT_MASTER
                                        ? {
                                            documentNumber:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.documentNumber
                                                    : "",
                                            documentName:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.documentName
                                                    : "",
                                            filePath:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.filePath
                                                    : "",
                                            entityId:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.entityMaster?.id
                                                    : "",
                                            entityTypeId:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.entityType?.id
                                                    : "",
                                            assetId:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.assets?.id
                                                    : "",
                                            assetTypeId:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.assetType?.id
                                                    : "",
                                            documentTypeId:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.documentType?.id
                                                    : "",
                                            registrationDate:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.registrationDate
                                                    : "",
                                            validDays:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.validDays
                                                    : "",
                                            expiryDate:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.expiryDate
                                                    : "",
                                            verificationStatus:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.verificationStatus
                                                    : "",
                                            verifiedById:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.verifiedById
                                                    : "",
                                            verifiedDate:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.verifiedDate
                                                    : "",
                                            remarks:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.remarks
                                                    : "",
                                            file:
                                                props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                    ? getByIdData && getByIdData.fileData
                                                    : "",
                                        }
                                        : {

                                        }
                            }
                            onSubmit={handleSubmit}
                        >
                            {({ values, setFieldValue, handleChange }) => (
                                <Form>
                                    <div>
                                        {props.reportName === REPORT_NAME.DOCUMENT_TYPE ? (
                                            <>
                                                <div className="mt-3">
                                                    <div>
                                                        <div className="d-flex"> <div>Code</div>
                                                            <div style={{ color: "red" }}>*</div>
                                                        </div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.code}
                                                            name={"code"}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div>
                                                        <div className="d-flex"> <div> {props.reportName} Name</div>
                                                            <div style={{ color: "red" }}>*</div>
                                                        </div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.name}
                                                            name={"name"}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div>
                                                        <div className="d-flex">
                                                            Description
                                                        </div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.description}
                                                            name={"description"}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Entity Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="entityTypeId"
                                                        value={values.entityTypeId}
                                                    >
                                                        <option value="">Select Entity Type</option>
                                                        {allEntityTypes?.map((type: any, index: number) => (
                                                            <option key={index} value={type.id}>
                                                                {type.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {/* <div className="mt-3">
                                                     <div className="d-flex">
                                                            File Format
                                                        </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="fileFormat"
                                                        value={values.fileFormat}
                                                    >
                                                        <option value="">Select File Format</option>
                                                        <option value="">PDF</option>
                                                        <option value="">JPG</option>
                                                        <option value="">Xlsx</option>
                                                        <option value="">docx</option>
                                                    </select>
                                                </div> */}
                                                <div className="mt-3">
                                                    <div>
                                                        <div className="d-flex">
                                                            File Format
                                                        </div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.fileFormat}
                                                            name={"fileFormat"}
                                                            placeholder="Pdf,jpg,xlsx,docx"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-column mt-3">
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="isMandatory"
                                                            name="isMandatory"
                                                            checked={values.isMandatory}
                                                            onChange={(e) => setFieldValue("isMandatory", e.target.checked)}
                                                        />
                                                        <label htmlFor="isMandatory" className="ms-1 text-secondary">
                                                            Is Mandatory
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="expiryApplicable"
                                                            name="expiryApplicable"
                                                            checked={values.expiryApplicable}
                                                            onChange={(e) => setFieldValue("expiryApplicable", e.target.checked)}
                                                        />
                                                        <label htmlFor="expiryApplicable" className="ms-1 text-secondary">
                                                            Expiray Applicable
                                                        </label>
                                                    </div>
                                                </div>
                                            </>

                                        ) : props.reportName === REPORT_NAME.DOCUMENT_MASTER ? (
                                            <>
                                                <div className="mt-3">
                                                    <div>
                                                        <div className="d-flex">Document Number</div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.documentNumber}
                                                            name={"documentNumber"}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div>
                                                        <div className="d-flex">Document Name</div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.documentName}
                                                            name={"documentName"}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Entity</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="entityId"
                                                        value={values.entityId}
                                                    >
                                                        <option value="">Select Entity</option>
                                                        {allEntityMaster?.map((entity: any, index: number) => (
                                                            <option key={index} value={entity.id}>
                                                                {entity.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Entity Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="entityTypeId"
                                                        value={values.entityTypeId}
                                                    >
                                                        <option value="">Select Entity Type</option>
                                                        {allEntityTypes?.map((type: any, index: number) => (
                                                            <option key={index} value={type.id}>
                                                                {type.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Document Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="documentTypeId"
                                                        value={values.documentTypeId}
                                                    >
                                                        <option value="">Select Document Type</option>
                                                        {allDocumentTypeData?.map((type: any, index: number) => (
                                                            <option key={index} value={type.id}>
                                                                {type.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mt-2">
                                                    <div className="d-flex">
                                                        <div>Asset</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="assetId"
                                                        value={values.assetId}
                                                    >
                                                        <option value="">Select Asset</option>
                                                        {allAssets?.map((asset: any, index: number) => (
                                                            <option key={index} value={asset.id}>
                                                                {asset.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mt-2">
                                                    <div className="d-flex">
                                                        <div>Asset Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="assetTypeId"
                                                        value={values.assetTypeId}
                                                    >
                                                        <option value="">Select Asset Type</option>
                                                        {allAssetType?.map((assetType: any, index: number) => (
                                                            <option key={index} value={assetType.id}>
                                                                {assetType.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div>Registeration Date</div>
                                                    <input
                                                        className="form-control form-control-sm w-50"
                                                        type="date"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={
                                                            values.registrationDate
                                                                ? format(parseISO(values.registrationDate), "yyyy-MM-dd")
                                                                : ""
                                                        }
                                                        name="registrationDate"
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>
                                                        <div className="d-flex">
                                                            Valid Days
                                                        </div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="number"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.validDays}
                                                            name={"validDays"}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div>Expiry Date</div>
                                                    <input
                                                        className="form-control form-control-sm w-50"
                                                        type="date"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={
                                                            values.expiryDate
                                                                ? format(parseISO(values.expiryDate), "yyyy-MM-dd")
                                                                : ""
                                                        }
                                                        name="expiryDate"
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>
                                                        <div className="d-flex">
                                                            Verfication Status
                                                        </div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.verificationStatus}
                                                            name={"verificationStatus"}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Verified By</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="verifiedById"
                                                        value={values.verifiedById}
                                                    >
                                                        <option value="">Select</option>
                                                        {allUsers?.map((user: any, index: number) => (
                                                            <option key={index} value={user.id}>
                                                                {user.firstName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div>Verified Date</div>
                                                    <input
                                                        className="form-control form-control-sm w-50"
                                                        type="date"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={
                                                            values.verifiedDate
                                                                ? format(parseISO(values.verifiedDate), "yyyy-MM-dd")
                                                                : ""
                                                        }
                                                        name="verifiedDate"
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>
                                                        <div className="d-flex">
                                                            Remarks
                                                        </div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.remarks}
                                                            name={"remarks"}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-2">
                                                    <div className="d-flex">
                                                        <div>Upload File</div>
                                                        <div style={{ color: "red" }}>*</div>
                                                    </div>
                                                    <input
                                                        type="file"
                                                        id="fileUpload"
                                                        className="ms-2"
                                                        onChange={(e: any) => {
                                                            fileHandler(e);
                                                            setFieldValue("file", e.target.files[0]);
                                                        }}
                                                        required
                                                    />
                                                    <hr />
                                                </div>
                                            </>
                                        ) : (
                                            <div className="row">
                                            </div>
                                        )}
                                    </div>
                                    <div className="d-flex flex-row justify-content-center">
                                        <button
                                            type="submit"
                                            className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                                        >
                                            {props.actionType === ACTION_TYPE.ADD_ACTION ? "Save" : "Update"}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                            onClick={handleClose}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                    )}
                    {activeTab === "bulk" && (
                        <div className="border p-3 rounded">
                            <div className="mb-3">
                                <label htmlFor="xlsxUpload" className="form-label">
                                    Upload .xlsx File <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".xlsx"
                                    id="xlsxUpload"
                                    onChange={handleBulkUpload}
                                />
                            </div>
                            <a
                                href={`/templates/${props.reportName === REPORT_NAME.DOCUMENT_TYPE
                                    ? "DOCUMENT_TYPE"
                                    : props.reportName === REPORT_NAME.DOCUMENT_MASTER
                                        ? "DOCUMENT_MASTER"
                                        : ""
                                    }.xlsx`}
                                download
                                className="btn btn-outline-secondary"
                            >
                                Download Sample .xlsx Template
                            </a>
                            <button
                                className="btn btn-primary mx-2 bg-accent"
                                onClick={handleBulkSave}
                                disabled={!file}
                            >
                                Save
                            </button>
                        </div>
                    )}


                </Modal.Body>
            </Modal >
        </>
    );

};

export default DocumentDate;